const convertToSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
};

const getJobLocation = (e) => {
  return $(e).find(".job-location").data("location");
};

const getType = (e) => {
  return $(e).find(".job-type").data("type");
};

export default {
  init() {
    const locations = [];
    const types = [];
    const blockName = ".block-jobs-openings";
    const block = $(blockName);
    const locationsSelect = $("#filter-by-location");
    const typeSelect = $("#filter-by-type");
    if (block.length) {
      const jobs = block.find(".job");
      jobs.each((i, e) => {
        const location = getJobLocation(e);
        if (!locations.includes(location)) {
          locations.push(location);
        }
        const type = getType(e);
        if (!types.includes(type)) {
          types.push(type);
        }
      });
      locations.forEach((location) => {
        locationsSelect.append(new Option(location, convertToSlug(location)));
      });

      types.forEach((type) => {
        typeSelect.append(new Option(type, convertToSlug(type)));
      });

      locationsSelect.on("change", (e) => {
        const selectedValue = $(e.delegateTarget).val();
        console.log("selectedValue:", selectedValue);
        if (selectedValue) {
          jobs.hide();
          jobs.each((i, e) => {
            const location = convertToSlug(getJobLocation(e));
            if (location == selectedValue) {
              $(e).show();
            }
          });
        } else {
          jobs.show();
        }
      });

      typeSelect.on("change", (e) => {
        const selectedValue = $(e.delegateTarget).val();
        console.log("selectedValue:", selectedValue);
        if (selectedValue) {
          jobs.hide();
          jobs.each((i, e) => {
            const type = convertToSlug(getType(e));
            if (type == selectedValue) {
              $(e).show();
            }
          });
        } else {
          jobs.show();
        }
      });
    }
  },
  finalize() {},
};
